import { baas } from "../../utils/apis";
import { ResourcePermission } from "../../utils/entitlements";

type EntitlementsRequest = {
  principal: { id: string };
  action: string;
  role: string;
  resources: ResourcePermission[];
};

type RawEntitlementsResponse = {
  resources?: Record<string, boolean>;
  allowed?: string[];
};

type Decision = "ALLOW" | "DENY";

type DecisionsResponse = {
  decisions?: Array<Record<string, Decision>>;
};

export async function fetchEntitlements(
  params: EntitlementsRequest,
): Promise<ResourcePermission[]> {
  const res = await baas.post<RawEntitlementsResponse & DecisionsResponse>(
    "/entitlements/admin_console",
    params,
  );

  const data = res.data;

  // 1) New shape: { decisions: [ { "ai:ask": "ALLOW" }, ... ] }
  if (Array.isArray((data as DecisionsResponse).decisions)) {
    return (data as DecisionsResponse)
      .decisions!.flatMap(entry => Object.entries(entry))
      .filter(([, decision]) => decision === "ALLOW")
      .map(([key]) => key as ResourcePermission);
  }

  // 2) Older shape: { allowed: [...] }
  if (Array.isArray((data as any).allowed)) {
    return (data as any).allowed as ResourcePermission[];
  }

  // 3) Older shape: { resources: { "ai:ask": true } }
  if ((data as any).resources && typeof (data as any).resources === "object") {
    return Object.entries((data as any).resources)
      .filter(([, ok]) => Boolean(ok))
      .map(([key]) => key as ResourcePermission);
  }

  return [];
}
